import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};
export const EditStateMaster = createSlice({
  name: "EditStateMaster",
  initialState: {
    isLoading: false,
    api_completed: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    edit_state_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_edit_state_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.api_completed = true;
      state.isSuccess = true;
      // SUCCESE(action.payload.message);
    },
    failure_api_call_edit_state_master: (state, action) => {
      state.api_completed = true;
      state.isLoading = false;
      state.isSuccess = false;
      // FAILED(action.payload);
    },
    edit_state_master_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
    edit_state_master_api_complete: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default EditStateMaster.reducer;
export const {
  edit_state_master,
  success_api_call_edit_state_master,
  edit_state_master_isSuccess,
  edit_state_master_api_complete,
  failure_api_call_edit_state_master,
} = EditStateMaster.actions;
